import React from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, CardHeader, ListGroup, ListGroupItem, Button } from 'reactstrap';
import { danismaKuruluData } from './danismaKuruluData'; // Veriyi import edin
import { Link } from 'react-router-dom';

function DanismaKurulu()
{
    return (
        <Container>
            <div class="row my-4">
                {danismaKuruluData.map((person, index) => (
                    <Col key={index} md="4" className='my-2'>
                        <Card className="person-card">
                            <div class="resim">
                                <img src={person?.imageUrl} className='border-bottom' alt={`${person?.firstName} ${person?.lastName}`} />
                            </div>
                            <CardHeader>
                                <div className="text-center">
                                    {person?.academicTitle} {person?.firstName} {person?.lastName}</div>
                            </CardHeader>
                            <CardBody>
                                <ListGroup flush>
                                    <ListGroupItem>
                                        {person?.university}
                                    </ListGroupItem>
                                    {/*<Button className='btn-primary'>*/}
                                    {/*<i class="bi bi-person-fill"></i> Detay*/}
                                    {/*</Button>*/}
                                </ListGroup>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </div>
        </Container>
    );
}
export default DanismaKurulu;
